import React from "react";

export default function FilterBar({ availableFilters, value, onChange }) {
  // availableFilters: {team: [...], role: [...]}
  const keys = Object.keys(availableFilters || {});
  if (keys.length === 0) return null;

  function setKey(k, v) {
    const next = { ...value };
    if (!v) delete next[k];
    else next[k] = v;
    onChange(next);
  }
  const hasAny = Object.keys(value).length > 0;

  return (
    <div className="flex items-center gap-3 flex-wrap" data-testid="filter-bar">
      <span className="eyebrow text-gray-500">Filter</span>
      {keys.map((k) => (
        <select
          key={k}
          value={value[k] || ""}
          onChange={(e) => setKey(k, e.target.value)}
          className="text-xs px-3 py-2 border border-gray-100 bg-paper"
          style={{ fontFamily: "Oswald", letterSpacing: "0.1em" }}
          data-testid={`filter-${k}`}
          aria-label={`Filter by ${k}`}
        >
          <option value="">All {k}s</option>
          {availableFilters[k].map((v) => (
            <option key={v} value={v}>
              {v}
            </option>
          ))}
        </select>
      ))}
      {hasAny && (
        <button
          onClick={() => onChange({})}
          className="btn-quiet text-xs"
          style={{ fontFamily: "Oswald", letterSpacing: "0.1em" }}
          data-testid="filter-clear"
        >
          CLEAR
        </button>
      )}
    </div>
  );
}
